jQuery(function ($) {
    var theme;
    var storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
        theme = storedTheme === 'light' ? 'light' : 'dark';
    } else {
        theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    setTheme(theme);

    var button = $('.dark-mode-toggle-button');
    button.click(function () {
        var theme = $('body').hasClass('dark') ? 'light' : 'dark';
        setTheme(theme);
        return false;
    });

    function setTheme(theme) {
        var body = $('body');
        body.addClass('no-transitions');
        body.toggleClass('dark', theme !== 'light');
        body.width(); // Force re-render.
        body.removeClass('no-transitions');
        localStorage.setItem('theme', theme);
    }
});
